import { jsLoadAnim, jsDeleteLoadAnim } from "../js/common/common";

export const stripePublicKey = 'pk_live_51RsZe4PJzWvdilTQwwBYe9tbuxALAnztBJwGR8eruvUAr4HAsyJMPQExkOeapjbgIpRjzKgH0JHJa3yUgOjcdWGo00GRdVWfN4';
// export const stripePublicKey = 'pk_test_51RsZeGAaDyT8m2t39tWZkBozhxAUjNzarB8hTIUxKdrDkZDh0YvGcAm40D4n4G0pbRWeXkifuJYcfHRIJkcanNQ600CD7GMNUK';
const stripe = Stripe(stripePublicKey);
const elements = stripe.elements();

const cardNumber = elements.create('cardNumber');
cardNumber.mount('#card-number');

const cardExpiry = elements.create('cardExpiry');
cardExpiry.mount('#card-expiry');

const cardCvc = elements.create('cardCvc');
cardCvc.mount('#card-cvc');

document.getElementById('card-form').addEventListener('submit', async (event) => {
  event.preventDefault();

  const animTarget = document.getElementById('detaile');
  jsLoadAnim(animTarget);

  const errorBox = document.getElementById('card-error');
  if (errorBox) errorBox.textContent = ''; // エラー表示領域を初期化

  try {
    const { clientSecret } = await fetch('/system/user/cart/setup-intent-api.php')
      .then(res => {
        if (!res.ok) throw new Error('SetupIntentの取得に失敗しました');
        return res.json();
      });

    const result = await stripe.confirmCardSetup(clientSecret, {
      payment_method: {
        card: cardNumber,
      },
    });

    if (result.error) {
      jsDeleteLoadAnim(animTarget);

      const code = result.error.code;
      let message = result.error.message;

      switch (code) {
        case 'card_declined':
          message = 'カードが拒否されました。別のカードをご利用ください。';
          break;
        case 'expired_card':
          message = 'カードの有効期限が切れています。';
          break;
        case 'incorrect_cvc':
          message = 'セキュリティコードが正しくありません。';
          break;
        case 'processing_error':
          message = 'カードの処理中にエラーが発生しました。';
          break;
        case 'setup_intent_authentication_failure':
          message = 'カード認証に失敗しました。';
          break;
        default:
          message = `カード登録に失敗しました：${message}`;
          break;
      }

      alert(message);
      return;
    }

    // 成功時の処理
    location.href = location.href;

  } catch (error) {
    console.error('致命的なエラー:', error);
    if (errorBox) errorBox.textContent = 'カード登録中にエラーが発生しました。もう一度お試しください。';
  }
});